import Image from "next/image";
// import Link from "next/link";

interface Props {
    imgSrc: string;
    // id?: string;
    altText?: string;
}

const VideoArea2 = ({ imgSrc = "#", altText = "" }: Props) => {
    return (
        <>
            <div className="desilo-video-area style-2 overflow-hidden ">
                <div className="container custom-container position-relative">
                    <div className="row">
                        <div className="col-12">
                            <div className="desilo-hero__thumb text-end">
                                <Image
                                    height={500}
                                    width={500}
                                    sizes="100vw"
                                    src={imgSrc}
                                    alt={altText}
                                    data-speed="0.8"
                                    className="w-100 h-100"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VideoArea2;
